import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { PRODUCT_DETAIL_CONTENT_ID_CONTAINER } from "../../../../constants";

const styles: StyleRulesCallback = ({ breakpoints, spacing: { unit } }) => ({
  container: {
    padding: `${unit * 4}px ${unit * 3}px ${unit * 10}px`,
    maxWidth: breakpoints.values.md,
    margin: "0 auto"
  }
});

const BaseMainContent: React.FC<WithStyles<typeof styles>> = ({ classes, children }) => (
  <div className={classes.container} data-id={PRODUCT_DETAIL_CONTENT_ID_CONTAINER}>
    {children}
  </div>
);

export const MainContent = withStyles(styles)(BaseMainContent);
